import { legacyLibrary as t } from "./legacy.js";
import { phosphorLibrary as l } from "./phosphor.js";
import { simpleLibrary as a } from "./simple.js";
const e = [t, l, a], b = e.flatMap(
  (i) => i.icons
);
function p(i) {
  function n(o, r) {
    if (o.belongsToLibrary(r))
      return o.resolveUrl(r);
  }
  for (const o of e) {
    const r = n(o, i);
    if (r)
      return r;
  }
}
export {
  b as availableIcons,
  e as libraries,
  p as resolveLibraryIcon
};
